import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { PronosticoHistoricoState } from './types'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const state: PronosticoHistoricoState = {
  pronosticoHistorico: [],
  link_descarga: '',
  isLoaded: false,
  error: { state: false }
}

const namespaced: boolean = true

export const pronosticoHistorico: Module<PronosticoHistoricoState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
